import { ROUTES } from '@ui/constants/routes';

export const isRoute = (routeLike: string): routeLike is ROUTES => {
  return Object.values(ROUTES).includes(routeLike as ROUTES);
};
